export const PROGRESS_BAR_CLASSIFY_LINK = 'ecaja-navigation-bar-classify';
export const PROGRESS_BAR_CLASSIFY = 'navigation-bar-classify';
export const PROGRESS_BAR_SELECT_AD_TYPE_LINK =
  'ecaja-navigation-bar-select-ad-type';
export const PROGRESS_BAR_SELECT_AD_TYPE = 'navigation-bar-select-ad-type';
export const PROGRESS_BAR_WRITE_LINK = 'ecaja-navigation-bar-write';
export const PROGRESS_BAR_WRITE = 'navigation-bar-write';
export const PROGRESS_BAR_SHORTLIST_LINK = 'ecaja-navigation-bar-shortlist';
export const PROGRESS_BAR_SHORTLIST = 'navigation-bar-shortlist';
export const PROGRESS_BAR_CHECKOUT_LINK = 'ecaja-navigation-bar-checkout';
export const PROGRESS_BAR_CHECKOUT = 'navigation-bar-checkout';
